module.exports = __webpack_public_path__ + "static/media/unlock-alt-solid.1300b35d.svg";